export const OPERATOR_NAMES = {
  '==': 'equal',
  '*': 'contain',
  '!=': 'not equal',
  '>': 'be greater than',
  '<': 'be less than',
  '!*': 'not contain',
  '^': 'starts with',
  '!^': 'not start with',
  $: 'ends with',
  '!$': 'not end with',
  '?': 'exist',
  '!?': 'not exist',
  in: 'be one of',
  'not in': 'not be one of',
  since: 'since',
  regex: 'regex',
  '> ago': 'have occurred more than',
  '< ago': 'have occurred less than',
  within: 'have occurred in the last',
  '< time': 'have occurred before',
  '> time': 'have occurred after',
};
